import React from "react"

const GlobalCustomContext = React.createContext({});

export function useGlobalCustomContext() {
    return React.useContext(GlobalCustomContext);
}

export default GlobalCustomContext;